import { useMutation } from "react-query";
import { postWithBearer } from "utils/authApi";
import { API_RESEND_EMAIL } from "consts";

export default function useResendEmail(config) {
  return useMutation(
    ({ password, mfaVerificationToken, accessToken }) =>
      postWithBearer(
        API_RESEND_EMAIL,
        { password, mfaVerificationToken },
        accessToken
      ),
    config
  );
}
